import React from 'react';
import compose from 'recompose/compose';
import defaultProps from 'recompose/defaultProps';
// import mapPropsOnChange from 'recompose/mapPropsOnChange';
import { Motion } from 'react-motion';
import { clusterMarkerHOC } from './ClusterMarker.js';
import './SimpleMarker.css';

export const simpleMarker = ({
  pointId, lat, lng, defaultMotionStyle, motionStyle, openFileDialog, zoom, setMapProps, isSelected, onPage
}) => {
  const handleClick = () => {
    if(!!openFileDialog){
      openFileDialog(pointId)
    }else{
      if (zoom < 14) {
        setMapProps({center: {lat, lng}, zoom: (zoom+1)})
      }
    }
  }

  let classNames = ['simple-marker'];
  if(isSelected){
    classNames.push('simple-selected');
  }
  if(onPage){
    classNames.push('simple-page');
  }

  return  (
    <Motion
      defaultStyle={defaultMotionStyle}
      style={motionStyle}
    >
    {
      ({ scale }) => (
        <div
          className={classNames.join(' ')}
          style={{
            transform: `translate3D(0,0,0) scale(${scale}, ${scale})`,
          }}
          onClick = {handleClick}
        >
        </div>
      )
    }
    </Motion>
  )
};

export const simpleMarkerHOC = compose(
  defaultProps({
    markerId: '',
    initialScale: 0.3,
    defaultScale: 0.6,
    hoveredScale: 0.7,
  }),
  // resuse HOC
  clusterMarkerHOC
);

export default simpleMarkerHOC(simpleMarker);